import React from 'react'

const EyeglassesIcon = () => (
  <svg
    width='146'
    height='58'
    viewBox='0 0 146 58'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden='true'
    focusable='false'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      // eslint-disable-next-line max-len
      d='M110.699 1.28604C95.7164 1.28604 83.5707 13.4317 83.5707 28.4142C83.5707 43.3966 95.7164 55.5423 110.699 55.5423C125.681 55.5423 137.827 43.3966 137.827 28.4142C137.827 13.4317 125.681 1.28604 110.699 1.28604ZM82.2847 28.4142C82.2847 12.7215 95.0061 0 110.699 0C126.392 0 139.113 12.7215 139.113 28.4142C139.113 44.1069 126.392 56.8283 110.699 56.8283C95.0061 56.8283 82.2847 44.1069 82.2847 28.4142Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      // eslint-disable-next-line max-len
      d='M34.7673 1.53226C19.7849 1.53226 7.63919 13.6779 7.63919 28.6604C7.63919 43.6429 19.7849 55.7885 34.7673 55.7885C49.7498 55.7885 61.8955 43.6429 61.8955 28.6604C61.8955 13.6779 49.7498 1.53226 34.7673 1.53226ZM6.35315 28.6604C6.35315 12.9677 19.0746 0.246216 34.7673 0.246216C50.46 0.246216 63.1815 12.9677 63.1815 28.6604C63.1815 44.3531 50.46 57.0746 34.7673 57.0746C19.0746 57.0746 6.35315 44.3531 6.35315 28.6604Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      // eslint-disable-next-line max-len
      d='M72.6871 10.439C66.8693 10.439 62.1526 15.1556 62.1526 20.9735C62.1526 21.3286 61.8647 21.6165 61.5096 21.6165C61.1545 21.6165 60.8666 21.3286 60.8666 20.9735C60.8666 14.4454 66.159 9.15295 72.6871 9.15295C79.2153 9.15295 84.5077 14.4454 84.5077 20.9735C84.5077 21.3286 84.2198 21.6165 83.8647 21.6165C83.5095 21.6165 83.2217 21.3286 83.2217 20.9735C83.2217 15.1556 78.505 10.439 72.6871 10.439Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      // eslint-disable-next-line max-len
      d='M0 25.934C0 25.5789 0.28789 25.291 0.643021 25.291H144.643C144.998 25.291 145.286 25.5789 145.286 25.934C145.286 26.2892 144.998 26.5771 144.643 26.5771H0.643021C0.28789 26.5771 0 26.2892 0 25.934Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      // eslint-disable-next-line max-len
      d='M97.8384 25.8089C97.8384 25.4538 98.1263 25.1659 98.4814 25.1659H99.9144C106.802 25.1659 113.406 27.9012 118.274 32.7729C118.275 32.7729 118.275 32.773 118.275 32.773L124.819 39.317C125.07 39.5681 125.07 39.9752 124.819 40.2263C124.567 40.4775 124.16 40.4775 123.909 40.2263L117.365 33.6822L117.365 33.682C112.738 29.0518 106.461 26.4519 99.9144 26.4519H98.4814C98.1263 26.4519 97.8384 26.164 97.8384 25.8089Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      // eslint-disable-next-line max-len
      d='M27.2137 33.0265C32.0817 28.1548 38.6865 25.4196 45.5737 25.4196H47.0067C47.3619 25.4196 47.6498 25.7074 47.6498 26.0626C47.6498 26.4177 47.3619 26.7056 47.0067 26.7056H45.5737C39.0274 26.7056 32.7498 29.3055 28.1232 33.9357L21.5789 40.48C21.3278 40.7311 20.9207 40.7311 20.6695 40.48C20.4184 40.2289 20.4184 39.8217 20.6695 39.5706L27.2137 33.0265C27.2137 33.0265 27.2136 33.0266 27.2137 33.0265Z'
      fill='currentColor'
    />
  </svg>
)

export default EyeglassesIcon
